import { render, staticRenderFns } from "./Detail-Template.vue?vue&type=template&id=4074cc2e&scoped=true"
import script from "./Detail-Template.vue?vue&type=script&lang=js"
export * from "./Detail-Template.vue?vue&type=script&lang=js"
import style0 from "./Detail-Template.vue?vue&type=style&index=0&id=4074cc2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4074cc2e",
  null
  
)

export default component.exports